<script>
import _ from "lodash";

export default {
  name: "TheStudentScholarshipCommentsCard",

  props: {
    comments: Array,
  },

  computed: {
    isCommentsPresent() {
      return !_.isNil(this.comments) && this.comments?.length > 0
    },
  },

  methods: {
    isLastComment(index) {
      return index !== this.comments.length - 1
    }
  },
}
</script>

<template>
  <v-card
    outlined
    flat
    rounded="xl"
    min-height="225px"
  >
    <v-card-title class="text-center title-wrap">
      Комментарии к заявлению
      <v-icon right>
        fa-comment
      </v-icon>
    </v-card-title>
    <v-divider/>
    <v-card-text v-if="isCommentsPresent" class="overflow-y-auto" style="max-height: 425px">
      <v-list>
        <div v-for="(comment, index) in comments" :key="comment.id">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="d-flex text-wrap">
                <v-icon small left>fa-comment</v-icon> {{comment.comment_text}}
              </v-list-item-title>
              <v-list-item-subtitle>
                Достижение: {{comment.achievement}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-show="isLastComment(index)"/>
        </div>
      </v-list>
    </v-card-text>

    <v-card-text v-else>
      Комментарии к данному заявлению отсутствуют
    </v-card-text>

  </v-card>
</template>

<style scoped>
.title-wrap {
  word-break: keep-all;
}
</style>